import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

// Ana projedeki shrd-master-layout'un sadeleştirilmiş prototip kabuğu.
// Migrate ederken bu kabuk atılır; sayfalar Master app route'larına bağlanır.
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  template: `
    <nav id="sidebar">
      <div class="sidebar-header">
        <div class="brand">aiDesk <span>Meeting</span></div>
        <p>AI Destekli Sanal Toplantı</p>
      </div>
      <div class="sidebar-menu">
        <ul>
          <li><a routerLink="/new" routerLinkActive="active"><i class="fa-solid fa-plus"></i> Yeni Toplantı</a></li>
          <li><a routerLink="/meetings" routerLinkActive="active"><i class="fa-regular fa-comments"></i> Toplantılar</a></li>
        </ul>
      </div>
      <div class="sidebar-footer">
        <span>Prototip • Çoklu katılımcı</span>
      </div>
    </nav>
    <div id="content">
      <router-outlet />
    </div>
  `,
  styles: [`
    :host { display: flex; min-height: 100dvh; }
    #sidebar {
      width: var(--sidebar-width); min-width: var(--sidebar-width);
      background-color: var(--sidebar-bg); color: var(--sidebar-color);
      display: flex; flex-direction: column; position: sticky; top: 0; height: 100dvh;
    }
    .sidebar-header { padding: 24px 20px; border-bottom: 1px solid rgba(255,255,255,.08); }
    .sidebar-header .brand { font-size: 22px; font-weight: 700; color: #fff; }
    .sidebar-header .brand span { color: var(--sidebar-accent); }
    .sidebar-header p { margin: 6px 0 0; font-size: 12px; opacity: .7; }
    .sidebar-menu { flex: 1; padding: 15px 10px; }
    .sidebar-menu ul { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 4px; }
    .sidebar-menu a {
      display: flex; align-items: center; gap: 10px; padding: 11px 14px; border-radius: 8px;
      color: var(--sidebar-color); text-decoration: none; font-size: 14px;
    }
    .sidebar-menu a:hover { background-color: var(--sidebar-hover); }
    .sidebar-menu a.active { background-color: var(--sidebar-accent); color: #fff; }
    .sidebar-footer { padding: 15px 20px; font-size: 11px; opacity: .6; border-top: 1px solid rgba(255,255,255,.08); }
    #content { flex: 1; min-width: 0; padding: 24px; }
    @media (max-width: 768px) {
      :host { flex-direction: column; }
      #sidebar { width: 100%; height: auto; position: static; }
    }
  `]
})
export class App {}
